import { Skeleton as UiSkeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

import { skeletonVariants, type SkeletonVariants } from '../../configs/skeleton.config'

import type { ComponentProps } from 'react'

export function Skeleton({ className, size, width, ...props }: ComponentProps<typeof UiSkeleton> & SkeletonVariants) {
  return <UiSkeleton className={cn(skeletonVariants({ size, width }), className)} {...props} />
}
